import React, { Component } from 'react';
import './SponsorPage.scss'

class SponsorPage extends Component{
    render() {
        return (
            <div className="main">
                <h3>Sponsored by: </h3>
                    <div className="row justify-content-md-center">
                        <img src="images/Pict/LOGO PEGADAIAN.png" className="logo-pegadaian" alt="logo pegadaian"></img>
                    </div>
                    <div className="row justify-content-md-center">
                        <video src="video/60s_NONSUB.mp4" className="video1" controls></video>
                    </div>
            </div>
        )
    }
}

export default SponsorPage